import AccountsLayout from "./AccountsLayout";
export default AccountsLayout;
